import Decimal from "decimal.js";

import { ItemDoc } from "@megaron/catalog-contracts";

export type ShippingPalletFactorItem = {
  item: ItemDoc;
  quantity: number;
};

export const calculateShippingPalletFactor = (items: ShippingPalletFactorItem[]): Decimal => {
  const factors = items.map(({ item, quantity }) => {
    if (!item.pallet) return 0;
    return new Decimal(quantity).div(item.pallet);
  });

  return Decimal.sum(0, ...factors);
};
